import type { ReactElement } from "react"

import { Outlet } from "react-router-dom"

import { Grid } from "@mui/material"

import { KonanLogo } from "../../../components/icons/KonanLogo"

/**
 * Layout component for entry module components
 * wrapping the component in a grid and placing logo on the top of the screen
 * @return {<EntryLayout />}
 */
export function EntryLayout(): ReactElement {
  return (
    <Grid container direction="column" alignItems="center" justifyContent="center" py={3} wrap="nowrap" gap={3}>
      <Grid item>
        <KonanLogo logoWidth={154} />
      </Grid>
      {/* This element will render the entry component responding the current url
        for more info visit: https://reactrouter.com/en/main/components/outlet */}
      <Outlet />
    </Grid>
  )
}
